import React, { FunctionComponent } from 'react';

import styles from './OwnersTitle.module.scss';

export const OwnersTitle: FunctionComponent = () => (
  <div className={styles.activitiesTitle}>
    <h4>Owners events this week</h4>
  </div>
);
